import { useEffect } from "react";

/**
 * ShortRedirect — instantly forwards a short marketing path (e.g. /ig)
 * to the full /support URL with UTM parameters, so the visitor lands on
 * the campaign page WITH the tracking tags intact.
 */
export default function ShortRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0A2342",
        color: "#C9A84C",
        fontFamily: "Georgia, serif",
        letterSpacing: "0.12em",
        fontSize: "13px",
        textTransform: "uppercase",
      }}
    >
      <span>Mediterranean Dream · …</span>
    </div>
  );
}
